import Service from "../../../Service";
import Axios from "../../../Config/API";
import { IProdutoSpeUsuario } from "../../../../Interfaces/Geral/Produtos/ProdutoSpeUsuario/ProdutoSpeUsuarioInterfaces";

export async function ListarUsuariosSpeDoProdutoService(idProduto: number) {
    return Service(
        Axios.get<Array<IProdutoSpeUsuario>>(
            `/home/produtospeusuario/listarusuariosvinculadosporproduto?idProduto=${idProduto}`
        )
    );
}
